import React from "react";
import { TeaserCard } from "../TeaserCard/TeaserCard";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import Button from "../Button/Button";
import { OptimizelyContentArea } from "../../types/optimizely/base";
import { MapToTeaserCardProps } from "./TeaserListBlock.utlis";
import Link from "../Link/Link";

interface TeaserListBlockProps {
  content: OptimizelyContentArea;
  allNewsLink: string;
  allNewsLabel: string;
  sectionLabel: string;
  navigateToArticleText?: string;
}

const TeaserListBlock = ({
  content,
  allNewsLink,
  allNewsLabel,
  sectionLabel,
  navigateToArticleText,
}: TeaserListBlockProps) => {
  const handleOnClick = () => window.open(allNewsLink, "_self");
  return (
    <section className="pt-20 md:pt-28 pb-32 md:pb-28 z-40 container">
      <div className="flex justify-between">
        <SectionHeading colorVariant="primary" title={sectionLabel} />

        {allNewsLink && allNewsLabel && (
          <Link
            text={allNewsLabel}
            href={allNewsLink}
            variant="link-primary"
            className="hidden md:inline-flex max-h-10"
          />
        )}
      </div>

      <div className="py-4 grid-cols-1 lg:grid-cols-3 grid gap-x-4 gap-y-12 mb-6">
        {content?.expandedValue?.map((page) => {
          const cardProps = MapToTeaserCardProps(page);

          if (cardProps === null) {
            return null;
          }
          return <TeaserCard key={page.contentLink.guidValue} {...cardProps} linkText={navigateToArticleText}/>;
        })}
      </div>

      <Button
        text="See all"
        onClick={handleOnClick}
        variant="text"
        className="md:hidden inline-flex max-h-10 w-full mt-10"
      />
    </section>
  );
};

export default TeaserListBlock;